import { Component, OnInit } from '@angular/core';
import {DialogDefinitionEditorBase} from "@shared/components/platform-tool/platform-tool-dialog-definition/models/dialog-defnition-models";
import {PlatformQuery} from "@shared/models/platform-query/platform-query";
import {Api} from "@shared/constants/common-field.constants";
import {PlatformQueryService} from "@core/services/platform-query.service";
import {DynamicItem} from "@shared/models/common.models";
import {take} from "rxjs/operators";

@Component({
    standalone: false,
    selector: 'app-dialog-definition-questionnaire-editor',
  templateUrl: './dialog-definition-questionnaire-editor.component.html',
  styleUrls: ['./dialog-definition-questionnaire-editor.component.scss']
})
export class DialogDefinitionQuestionnaireEditorComponent extends DialogDefinitionEditorBase {
  items: DynamicItem[];

  constructor(private platformQueryService: PlatformQueryService) {
    super();
  }

  ngOnInit(): void {
    const flowchartId = this.dialogField.fieldValues['FlowchartId'];
    const qnrItemQuery = new PlatformQuery();
    qnrItemQuery.name = 'FileStoreDataItemsDialogModelQuery';
    qnrItemQuery.api = Api.FileStoreApi;
    qnrItemQuery.setValue('FlowchartId', flowchartId);
    this.platformQueryService.executeQuery(qnrItemQuery).pipe(take(1)).subscribe(response => {
      this.items = response.fieldValues['PlatformDialogs'];
    })
  }

}
